import { Component, HostBinding, inject, Input } from '@angular/core';
import { ASSETS_PATH_ABSOLUTE } from '../../pipes/asset.pipe';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { map, shareReplay } from 'rxjs';
import { SiteOwners } from '@orderform/widgets';

@Component({
  selector: 'orderform-payment-progress-indicator',
  templateUrl: './payment-progress-indicator.component.html',
  styleUrls: ['./payment-progress-indicator.component.scss'],
})
export class PaymentProgressIndicatorComponent {
  @HostBinding('class') @Input() state: 'pending' | 'ready' = 'pending';
  @Input() hiddenIndicator = false;
  staticBrand = (window as any).SITEOWNER_BRAND;
  logoUrl = `${ASSETS_PATH_ABSOLUTE}de/assets/brand/${this.staticBrand}/logo/logo_inverse.svg`;
  private _orderformFascade = inject(OrderformFascade);
  resellerId$ = this._orderformFascade.rootState$?.pipe(
    map((e) => e.order.settings.config.siteowner_id),
    shareReplay(1)
  );
  SiteOwners = SiteOwners;
}
